import { UserSessionMocks } from './user-session.mocks';

export const SharedEntitiesMocks = {
  'aem-feature-flags': {
    id: 'aem-feature-flags',
    aemFeatureFlags: {
      flags: {
        earns: {
          partners: true
        }
      }
    }
  },
  'aem-content': {
    id: 'aem-content',
    aemContent: {
      campaignId: {
        partners: 'ng-skymiles:partners',
        format: 'json'
      }
    }
  },
  'user-session': {
    id: 'user-session',
    userSession: UserSessionMocks
  },
  'partners-content': {
    id: 'partners-content',
    partnersContent: {
      id: 'test-id',
      partnersContent: 'test-content'
    }
  },
  'partners-content-error': {
    id: 'partners-content-error',
    partnersContentError: 'test-error'
  },
  'error-messages-content': {
    id: 'error-messages-content',
    errorMessagesContent: {
      'test-key': 'test-message'
    }
  }
};
